if (!customElements.get('delivery-step')) {
	class DeliveryStep extends HTMLElement {
		connectedCallback() {
			this._updateContent();
		}
		get minOffset() {
			if (this.lastStep) {
				return Math.max(this.offsets[0] - this.lastStep.maxOffset, 0);
			}
			return this.offsets[0];
		}
		get maxOffset() {
			if (this.lastStep) {
				return Math.max(this.offsets[1] - this.lastStep.maxOffset);
			}
			return this.offsets[1];
		}
		get offsets() {
			return JSON.parse(this.getAttribute('offsets'));
		}
		get vacationDays() {
			return JSON.parse(this.getAttribute('vacation-days'));
		}
		get cutOffTime() {
			return this.getAttribute('cut-off-time');
		}
		get weekendDays() {
			const weekendDays = JSON.parse(this.getAttribute('weekend-days'))
				? JSON.parse(this.getAttribute('weekend-days'))
				: [];
			return weekendDays.map(this._convertWeekdayNamesToNumber);
		}
		get startingDate() {
			if (this.lastStep) {
				return this.lastStep.maxDate;
			}
			return this.getAttribute('starting-date');
		}
		get ignoreCutOffTime() {
			return this.getAttribute('ignore-cut-off-time') === 'true';
		}
		get lastStep() {
			if (this.getAttribute('last-step-id')) {
				return document.getElementById(this.getAttribute('last-step-id'));
			}
			return null;
		}
		set minDate(date) {
			this.setAttribute('min-date', date);
		}
		set maxDate(date) {
			this.setAttribute('max-date', date);
		}
		get minDate() {
			return this.getAttribute('min-date');
		}
		get maxDate() {
			return this.getAttribute('max-date');
		}
		_convertWeekdayNamesToNumber(weekday) {
			const weekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
			return weekdays.indexOf(weekday.toLowerCase());
		}
		_formatDate(minDate, maxDate) {
			const minDay = minDate.toLocaleString('default', { day: '2-digit' });
			const minMonth = minDate.toLocaleString('default', { month: 'short' });
			const maxDay = maxDate.toLocaleString('default', { day: '2-digit' });
			const maxMonth = maxDate.toLocaleString('default', { month: 'short' });
			if (this.minOffset !== this.maxOffset && minMonth === maxMonth) {
				return theme.strings.deliveryDateSameMonth
					.replace('{{day}}', minDay)
					.replace('{{month}}', minMonth)
					.replace('{{max_day}}', maxDay);
			} else if (this.minOffset !== this.maxOffset) {
				return theme.strings.deliveryDatesDiffMonth
					.replace('{{max_day}}', maxDay)
					.replace('{{max_month}}', maxMonth)
					.replace('{{day}}', minDay)
					.replace('{{month}}', minMonth);
			} else {
				return theme.strings.deliveryDateOneDate.replace('{{day}}', minDay).replace('{{month}}', minMonth);
			}
		}
		_addDaysSkippingWeekendsAndVacations(daysToAdd) {
			let currentDate = this.startingDate ? new Date(this.startingDate) : new Date();
			if (this._isStartingDateWeekendOrVacation()) {
				currentDate = this._getFirstNonWeekendOrVacationDay();
			}
			let addedDays = 0;
			while (addedDays < daysToAdd) {
				currentDate.setDate(currentDate.getDate() + 1);
				if (this.weekendDays.includes(currentDate.getDay())) continue;

				const dateString = currentDate.toISOString().split('T')[0];
				if (this.vacationDays.includes(dateString)) continue;
				addedDays++;
			}
			return currentDate;
		}
		_isStartingDateWeekendOrVacation() {
			const startingDate = this.startingDate ? new Date(this.startingDate) : new Date();
			const dateString = startingDate.toISOString().split('T')[0];
			return this.vacationDays.includes(dateString) || this.weekendDays.includes(startingDate.getDay());
		}
		_getFirstNonWeekendOrVacationDay() {
			let currentDate = this.startingDate ? new Date(this.startingDate) : new Date();
			while (true) {
				currentDate.setDate(currentDate.getDate() + 1);
				if (this.weekendDays.includes(currentDate.getDay())) continue;
				const dateString = currentDate.toISOString().split('T')[0];
				if (this.vacationDays.includes(dateString)) continue;
				break;
			}
			return currentDate;
		}
		_isAfterCutOffTime() {
			const now = this.startingDate ? new Date(this.startingDate) : new Date();

			const hours = now.getHours();
			const minutes = now.getMinutes();

			const currentTimeFormatted = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;

			return currentTimeFormatted > this.cutOffTime;
		}
		_updateContent() {
			const cutOffOffset = this.ignoreCutOffTime ? 0 : this._isAfterCutOffTime() ? 1 : 0;
			const minAddedDays = this.minOffset + cutOffOffset;
			const maxAddedDays = this.maxOffset + cutOffOffset;
			const minDate = this._addDaysSkippingWeekendsAndVacations(minAddedDays);
			const maxDate = this._addDaysSkippingWeekendsAndVacations(maxAddedDays);
			this.minDate = minDate.toISOString().split('T')[0];
			this.maxDate = maxDate.toISOString().split('T')[0];
			this.innerHTML = this._formatDate(minDate, maxDate);
		}
	}
	window.customElements.define('delivery-step', DeliveryStep);
}
